export const AUTH_PATTERN = {
  email:
    /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/,
  password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,20})/
};

export const AUTH_VALIDATION_CONFIG = {
  password: {
    minLength: 8,
    maxLength: 20
  },

  sixDigitCode: {
    length: 8
  }
};

// The values below are i18n keys, not literals. They are handed to
// react-hook-form as the `message` of a validation rule from module scope,
// where no hook context (and therefore no `t`) is available, so translation
// happens at the single point where a form error is rendered — see
// `common/components/form/input.component.tsx` and `six-digit-input.component.tsx`.
// Before this, every form on the site reported validation failures in English
// no matter which language the visitor had selected.
export const PasswordErrors = {
  required: 'validation.password.required',
  pattern: 'validation.password.pattern',
  minLength: 'validation.password.minLength',
  maxLength: 'validation.password.maxLength',
  notMatch: 'validation.password.notMatch',
  same: 'validation.password.same',
  wrong: 'validation.password.wrong'
};

export const EmailErrors = {
  required: 'validation.email.required',
  pattern: 'validation.email.pattern',
  taken: 'validation.email.taken',
  same: 'validation.email.same'
};

export const TermsErrors = {
  required: 'validation.terms.required'
};

export const CodeErrors = {
  required: 'validation.code.required',
  incorrect: 'validation.code.incorrect',
  expired: 'validation.code.expired',
  alreadyCofirmed: 'validation.code.alreadyConfirmed'
};
